// Nogomandala - baza igrača za "Pogodi igrača" igru
// HNL aktivni + hrvatska reprezentacija + nekoliko legendi
//
// Atributi (svaki igrač ima svih 7):
//   klub        - trenutni klub (string)
//   liga        - liga u kojoj klub igra (string)
//   pozicija    - GK | DEF | MID | FWD
//   subPozicija - precizna pozicija (npr. "Lijevi bek", "Defenzivni vezni") - koristi se za "blizu" žuto
//   nacionalnost- država reprezentacije (string)
//   kontinent   - za "blizu" usporedbu nacionalnosti
//   datumRodjenja - YYYY-MM-DD; iz njega se računa dob na današnji dan
//   brojDresa   - broj na dresu (number)
//   visinaCm    - visina u cm (number)
//
// Napomena: brojevi dresa i klubovi mogu biti netočni za neku tekuću sezonu.
// Validirati prije produkcije.

export const PLAYERS = [
  // === HRVATSKA REPREZENTACIJA - aktivni ===
  {
    id: 'modric',
    ime: 'Luka Modrić',
    aliasi: ['Modric', 'Luka Modric', 'Modrić'],
    klub: 'Real Madrid',
    liga: 'La Liga',
    pozicija: 'MID',
    subPozicija: 'Vezni',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1985-09-09',
    brojDresa: 10,
    visinaCm: 172,
  },
  {
    id: 'kovacic',
    ime: 'Mateo Kovačić',
    aliasi: ['Kovacic', 'Mateo Kovacic'],
    klub: 'Manchester City',
    liga: 'Premier League',
    pozicija: 'MID',
    subPozicija: 'Vezni',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1994-05-06',
    brojDresa: 8,
    visinaCm: 176,
  },
  {
    id: 'brozovic',
    ime: 'Marcelo Brozović',
    aliasi: ['Brozovic'],
    klub: 'Al-Nassr',
    liga: 'Saudi Pro League',
    pozicija: 'MID',
    subPozicija: 'Defenzivni vezni',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1992-11-16',
    brojDresa: 77,
    visinaCm: 181,
  },
  {
    id: 'perisic',
    ime: 'Ivan Perišić',
    aliasi: ['Perisic'],
    klub: 'PSV Eindhoven',
    liga: 'Eredivisie',
    pozicija: 'FWD',
    subPozicija: 'Lijevo krilo',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1989-02-02',
    brojDresa: 4,
    visinaCm: 187,
  },
  {
    id: 'kramaric',
    ime: 'Andrej Kramarić',
    aliasi: ['Kramaric'],
    klub: 'Hoffenheim',
    liga: 'Bundesliga',
    pozicija: 'FWD',
    subPozicija: 'Napadač',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1991-06-19',
    brojDresa: 27,
    visinaCm: 177,
  },
  {
    id: 'livakovic',
    ime: 'Dominik Livaković',
    aliasi: ['Livakovic'],
    klub: 'Dinamo Zagreb',
    liga: 'HNL',
    pozicija: 'GK',
    subPozicija: 'Vratar',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1995-01-09',
    brojDresa: 40,
    visinaCm: 188,
  },
  {
    id: 'gvardiol',
    ime: 'Joško Gvardiol',
    aliasi: ['Gvardiol', 'Josko Gvardiol'],
    klub: 'Manchester City',
    liga: 'Premier League',
    pozicija: 'DEF',
    subPozicija: 'Stoper',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '2002-01-23',
    brojDresa: 24,
    visinaCm: 185,
  },
  {
    id: 'sosa',
    ime: 'Borna Sosa',
    aliasi: ['Sosa'],
    klub: 'Ajax',
    liga: 'Eredivisie',
    pozicija: 'DEF',
    subPozicija: 'Lijevi bek',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1998-01-21',
    brojDresa: 19,
    visinaCm: 187,
  },
  {
    id: 'juranovic',
    ime: 'Josip Juranović',
    aliasi: ['Juranovic'],
    klub: 'Union Berlin',
    liga: 'Bundesliga',
    pozicija: 'DEF',
    subPozicija: 'Desni bek',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1995-08-16',
    brojDresa: 22,
    visinaCm: 175,
  },
  {
    id: 'sutalo',
    ime: 'Joško Šutalo',
    aliasi: ['Sutalo', 'Josko Sutalo'],
    klub: 'Ajax',
    liga: 'Eredivisie',
    pozicija: 'DEF',
    subPozicija: 'Stoper',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '2000-02-28',
    brojDresa: 6,
    visinaCm: 188,
  },
  {
    id: 'erlic',
    ime: 'Martin Erlić',
    aliasi: ['Erlic'],
    klub: 'Sassuolo',
    liga: 'Serie B',
    pozicija: 'DEF',
    subPozicija: 'Stoper',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1998-01-24',
    brojDresa: 23,
    visinaCm: 191,
  },
  {
    id: 'pongracic',
    ime: 'Marin Pongračić',
    aliasi: ['Pongracic'],
    klub: 'Fiorentina',
    liga: 'Serie A',
    pozicija: 'DEF',
    subPozicija: 'Stoper',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1997-09-11',
    brojDresa: 5,
    visinaCm: 192,
  },
  {
    id: 'majer',
    ime: 'Lovro Majer',
    aliasi: ['Majer'],
    klub: 'Wolfsburg',
    liga: 'Bundesliga',
    pozicija: 'MID',
    subPozicija: 'Ofenzivni vezni',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1998-01-17',
    brojDresa: 27,
    visinaCm: 175,
  },
  {
    id: 'sucic',
    ime: 'Luka Sučić',
    aliasi: ['Sucic'],
    klub: 'Real Sociedad',
    liga: 'La Liga',
    pozicija: 'MID',
    subPozicija: 'Vezni',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '2002-09-08',
    brojDresa: 10,
    visinaCm: 184,
  },
  {
    id: 'pasalic',
    ime: 'Mario Pašalić',
    aliasi: ['Pasalic'],
    klub: 'Atalanta',
    liga: 'Serie A',
    pozicija: 'MID',
    subPozicija: 'Ofenzivni vezni',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1995-02-09',
    brojDresa: 8,
    visinaCm: 186,
  },
  {
    id: 'vlasic',
    ime: 'Nikola Vlašić',
    aliasi: ['Vlasic'],
    klub: 'Torino',
    liga: 'Serie A',
    pozicija: 'MID',
    subPozicija: 'Ofenzivni vezni',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1997-10-04',
    brojDresa: 16,
    visinaCm: 178,
  },
  {
    id: 'budimir',
    ime: 'Ante Budimir',
    aliasi: ['Budimir'],
    klub: 'Osasuna',
    liga: 'La Liga',
    pozicija: 'FWD',
    subPozicija: 'Napadač',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1991-07-22',
    brojDresa: 17,
    visinaCm: 190,
  },
  {
    id: 'petkovic',
    ime: 'Bruno Petković',
    aliasi: ['Petkovic'],
    klub: 'Dinamo Zagreb',
    liga: 'HNL',
    pozicija: 'FWD',
    subPozicija: 'Napadač',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1994-09-16',
    brojDresa: 9,
    visinaCm: 194,
  },
  {
    id: 'baturina',
    ime: 'Martin Baturina',
    aliasi: ['Baturina'],
    klub: 'Como',
    liga: 'Serie A',
    pozicija: 'MID',
    subPozicija: 'Ofenzivni vezni',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '2003-02-16',
    brojDresa: 10,
    visinaCm: 178,
  },

  // === HAJDUK SPLIT ===
  {
    id: 'kalinic-lukas',
    ime: 'Lukas Kalinić',
    aliasi: ['Kalinic', 'Lukas Kalinic'],
    klub: 'Hajduk Split',
    liga: 'HNL',
    pozicija: 'FWD',
    subPozicija: 'Napadač',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '2001-07-09',
    brojDresa: 17,
    visinaCm: 184,
  },
  {
    id: 'livaja',
    ime: 'Marko Livaja',
    aliasi: ['Livaja'],
    klub: 'Hajduk Split',
    liga: 'HNL',
    pozicija: 'FWD',
    subPozicija: 'Napadač',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1993-08-26',
    brojDresa: 10,
    visinaCm: 184,
  },
  {
    id: 'kalik',
    ime: 'Filip Uremović',
    aliasi: ['Uremovic', 'Uremović'],
    klub: 'Hajduk Split',
    liga: 'HNL',
    pozicija: 'DEF',
    subPozicija: 'Stoper',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1997-02-11',
    brojDresa: 24,
    visinaCm: 187,
  },
  {
    id: 'sigur',
    ime: 'Šarlija Niko',
    aliasi: ['Sigur', 'Sarlija'],
    klub: 'Hajduk Split',
    liga: 'HNL',
    pozicija: 'DEF',
    subPozicija: 'Stoper',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1995-04-25',
    brojDresa: 5,
    visinaCm: 189,
  },
  {
    id: 'pukstas',
    ime: 'Rokas Pukštas',
    aliasi: ['Pukstas'],
    klub: 'Hajduk Split',
    liga: 'HNL',
    pozicija: 'MID',
    subPozicija: 'Vezni',
    nacionalnost: 'SAD',
    kontinent: 'Sjeverna Amerika',
    datumRodjenja: '2004-08-11',
    brojDresa: 6,
    visinaCm: 188,
  },
  {
    id: 'krovinovic',
    ime: 'Filip Krovinović',
    aliasi: ['Krovinovic'],
    klub: 'Hajduk Split',
    liga: 'HNL',
    pozicija: 'MID',
    subPozicija: 'Ofenzivni vezni',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1995-08-29',
    brojDresa: 8,
    visinaCm: 175,
  },
  {
    id: 'mlakar',
    ime: 'Jan Mlakar',
    aliasi: ['Mlakar'],
    klub: 'Hajduk Split',
    liga: 'HNL',
    pozicija: 'FWD',
    subPozicija: 'Lijevo krilo',
    nacionalnost: 'Slovenija',
    kontinent: 'Europa',
    datumRodjenja: '1998-10-23',
    brojDresa: 30,
    visinaCm: 184,
  },
  {
    id: 'almena',
    ime: 'Anthony Kalik',
    aliasi: ['Kalik'],
    klub: 'Hajduk Split',
    liga: 'HNL',
    pozicija: 'MID',
    subPozicija: 'Ofenzivni vezni',
    nacionalnost: 'Australija',
    kontinent: 'Oceanija',
    datumRodjenja: '1996-08-22',
    brojDresa: 23,
    visinaCm: 178,
  },
  {
    id: 'rebic-ante',
    ime: 'Ante Rebić',
    aliasi: ['Rebic'],
    klub: 'Lecce',
    liga: 'Serie A',
    pozicija: 'FWD',
    subPozicija: 'Krilo',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1993-09-21',
    brojDresa: 18,
    visinaCm: 185,
  },

  // === DINAMO ZAGREB ===
  {
    id: 'baturina-dz',
    ime: 'Sandro Kulenović',
    aliasi: ['Kulenovic'],
    klub: 'Dinamo Zagreb',
    liga: 'HNL',
    pozicija: 'FWD',
    subPozicija: 'Napadač',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1999-09-02',
    brojDresa: 21,
    visinaCm: 184,
  },
  {
    id: 'spikic',
    ime: 'Dario Špikić',
    aliasi: ['Spikic'],
    klub: 'Dinamo Zagreb',
    liga: 'HNL',
    pozicija: 'FWD',
    subPozicija: 'Krilo',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1999-04-13',
    brojDresa: 11,
    visinaCm: 178,
  },
  {
    id: 'mikic',
    ime: 'Stefan Ristovski',
    aliasi: ['Ristovski'],
    klub: 'Dinamo Zagreb',
    liga: 'HNL',
    pozicija: 'DEF',
    subPozicija: 'Desni bek',
    nacionalnost: 'Sjeverna Makedonija',
    kontinent: 'Europa',
    datumRodjenja: '1992-02-12',
    brojDresa: 22,
    visinaCm: 181,
  },
  {
    id: 'theophile',
    ime: 'Kévin Théophile-Catherine',
    aliasi: ['Theophile-Catherine', 'Theophile'],
    klub: 'Dinamo Zagreb',
    liga: 'HNL',
    pozicija: 'DEF',
    subPozicija: 'Stoper',
    nacionalnost: 'Francuska',
    kontinent: 'Europa',
    datumRodjenja: '1989-10-28',
    brojDresa: 4,
    visinaCm: 182,
  },
  {
    id: 'ademi',
    ime: 'Arijan Ademi',
    aliasi: ['Ademi'],
    klub: 'Dinamo Zagreb',
    liga: 'HNL',
    pozicija: 'MID',
    subPozicija: 'Defenzivni vezni',
    nacionalnost: 'Sjeverna Makedonija',
    kontinent: 'Europa',
    datumRodjenja: '1991-05-29',
    brojDresa: 6,
    visinaCm: 184,
  },
  {
    id: 'misic',
    ime: 'Josip Mišić',
    aliasi: ['Misic'],
    klub: 'Dinamo Zagreb',
    liga: 'HNL',
    pozicija: 'MID',
    subPozicija: 'Vezni',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1994-07-28',
    brojDresa: 8,
    visinaCm: 178,
  },
  {
    id: 'ljubicic',
    ime: 'Robert Ljubičić',
    aliasi: ['Ljubicic'],
    klub: 'Dinamo Zagreb',
    liga: 'HNL',
    pozicija: 'MID',
    subPozicija: 'Vezni',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1999-06-02',
    brojDresa: 27,
    visinaCm: 184,
  },
  {
    id: 'nevistic',
    ime: 'Ivan Nevistić',
    aliasi: ['Nevistic'],
    klub: 'Dinamo Zagreb',
    liga: 'HNL',
    pozicija: 'GK',
    subPozicija: 'Vratar',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1998-07-31',
    brojDresa: 1,
    visinaCm: 192,
  },
  {
    id: 'pjaca',
    ime: 'Marko Pjaca',
    aliasi: ['Pjaca'],
    klub: 'Rijeka',
    liga: 'HNL',
    pozicija: 'FWD',
    subPozicija: 'Krilo',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1995-05-06',
    brojDresa: 22,
    visinaCm: 184,
  },

  // === RIJEKA ===
  {
    id: 'fruk',
    ime: 'Toni Fruk',
    aliasi: ['Fruk'],
    klub: 'Rijeka',
    liga: 'HNL',
    pozicija: 'MID',
    subPozicija: 'Ofenzivni vezni',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '2001-09-04',
    brojDresa: 8,
    visinaCm: 176,
  },
  {
    id: 'ndockyt',
    ime: 'Lindon Selahi',
    aliasi: ['Selahi'],
    klub: 'Rijeka',
    liga: 'HNL',
    pozicija: 'MID',
    subPozicija: 'Defenzivni vezni',
    nacionalnost: 'Sjeverna Makedonija',
    kontinent: 'Europa',
    datumRodjenja: '1998-04-16',
    brojDresa: 6,
    visinaCm: 184,
  },
  {
    id: 'zlomislic',
    ime: 'Ivan Smolčić',
    aliasi: ['Smolcic'],
    klub: 'Rijeka',
    liga: 'HNL',
    pozicija: 'DEF',
    subPozicija: 'Stoper',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '2001-03-23',
    brojDresa: 4,
    visinaCm: 188,
  },
  {
    id: 'jankovic',
    ime: 'Niko Janković',
    aliasi: ['Jankovic'],
    klub: 'Rijeka',
    liga: 'HNL',
    pozicija: 'FWD',
    subPozicija: 'Napadač',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1999-09-21',
    brojDresa: 9,
    visinaCm: 187,
  },
  {
    id: 'majstorovic',
    ime: 'Niko Galešić',
    aliasi: ['Galesic'],
    klub: 'Rijeka',
    liga: 'HNL',
    pozicija: 'DEF',
    subPozicija: 'Stoper',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1995-04-08',
    brojDresa: 5,
    visinaCm: 187,
  },
  {
    id: 'zlomislic-gk',
    ime: 'Martin Zlomislić',
    aliasi: ['Zlomislic'],
    klub: 'Rijeka',
    liga: 'HNL',
    pozicija: 'GK',
    subPozicija: 'Vratar',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1999-04-06',
    brojDresa: 1,
    visinaCm: 191,
  },

  // === OSIJEK ===
  {
    id: 'malenica',
    ime: 'Ivica Ivušić',
    aliasi: ['Ivusic'],
    klub: 'Osijek',
    liga: 'HNL',
    pozicija: 'GK',
    subPozicija: 'Vratar',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1995-02-01',
    brojDresa: 1,
    visinaCm: 195,
  },
  {
    id: 'mioc',
    ime: 'Ramon Mierez',
    aliasi: ['Mierez'],
    klub: 'Osijek',
    liga: 'HNL',
    pozicija: 'FWD',
    subPozicija: 'Napadač',
    nacionalnost: 'Argentina',
    kontinent: 'Južna Amerika',
    datumRodjenja: '1996-06-21',
    brojDresa: 9,
    visinaCm: 190,
  },
  {
    id: 'kleinheisler',
    ime: 'László Kleinheisler',
    aliasi: ['Kleinheisler'],
    klub: 'Osijek',
    liga: 'HNL',
    pozicija: 'MID',
    subPozicija: 'Ofenzivni vezni',
    nacionalnost: 'Mađarska',
    kontinent: 'Europa',
    datumRodjenja: '1994-04-08',
    brojDresa: 10,
    visinaCm: 178,
  },
  {
    id: 'jugovic',
    ime: 'Petar Bočkaj',
    aliasi: ['Bockaj'],
    klub: 'Osijek',
    liga: 'HNL',
    pozicija: 'MID',
    subPozicija: 'Vezni',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1994-09-04',
    brojDresa: 8,
    visinaCm: 180,
  },

  // === LOKOMOTIVA / SLAVEN BELUPO / ISTRA ===
  {
    id: 'jakirovic',
    ime: 'Marko Jakolis',
    aliasi: ['Jakolis'],
    klub: 'Slaven Belupo',
    liga: 'HNL',
    pozicija: 'FWD',
    subPozicija: 'Krilo',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1996-12-20',
    brojDresa: 17,
    visinaCm: 174,
  },
  {
    id: 'krstanovic',
    ime: 'Mirko Marić',
    aliasi: ['Maric', 'Mirko Maric'],
    klub: 'Lokomotiva',
    liga: 'HNL',
    pozicija: 'FWD',
    subPozicija: 'Napadač',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1995-05-16',
    brojDresa: 9,
    visinaCm: 192,
  },

  // === HRVATSKE LEGENDE ===
  {
    id: 'boban',
    ime: 'Zvonimir Boban',
    aliasi: ['Boban'],
    klub: 'Milan (legenda)',
    liga: 'Serie A',
    pozicija: 'MID',
    subPozicija: 'Ofenzivni vezni',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1968-10-08',
    brojDresa: 10,
    visinaCm: 185,
  },
  {
    id: 'suker',
    ime: 'Davor Šuker',
    aliasi: ['Suker'],
    klub: 'Real Madrid (legenda)',
    liga: 'La Liga',
    pozicija: 'FWD',
    subPozicija: 'Napadač',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1968-01-01',
    brojDresa: 9,
    visinaCm: 185,
  },
  {
    id: 'prosinecki',
    ime: 'Robert Prosinečki',
    aliasi: ['Prosinecki'],
    klub: 'Real Madrid (legenda)',
    liga: 'La Liga',
    pozicija: 'MID',
    subPozicija: 'Ofenzivni vezni',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1969-01-12',
    brojDresa: 10,
    visinaCm: 185,
  },
  {
    id: 'asanovic',
    ime: 'Aljoša Asanović',
    aliasi: ['Asanovic'],
    klub: 'Hajduk Split (legenda)',
    liga: 'HNL',
    pozicija: 'MID',
    subPozicija: 'Vezni',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1965-12-14',
    brojDresa: 8,
    visinaCm: 178,
  },
  {
    id: 'jarni',
    ime: 'Robert Jarni',
    aliasi: ['Jarni'],
    klub: 'Real Betis (legenda)',
    liga: 'La Liga',
    pozicija: 'DEF',
    subPozicija: 'Lijevi bek',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1968-10-26',
    brojDresa: 3,
    visinaCm: 178,
  },
  {
    id: 'olic',
    ime: 'Ivica Olić',
    aliasi: ['Olic'],
    klub: 'Bayern (legenda)',
    liga: 'Bundesliga',
    pozicija: 'FWD',
    subPozicija: 'Napadač',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1979-09-14',
    brojDresa: 11,
    visinaCm: 181,
  },
  {
    id: 'srna',
    ime: 'Darijo Srna',
    aliasi: ['Srna'],
    klub: 'Šahtar (legenda)',
    liga: 'Premier Liga UA',
    pozicija: 'DEF',
    subPozicija: 'Desni bek',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1982-05-01',
    brojDresa: 11,
    visinaCm: 178,
  },
  {
    id: 'rakitic',
    ime: 'Ivan Rakitić',
    aliasi: ['Rakitic'],
    klub: 'Hajduk Split (legenda)',
    liga: 'HNL',
    pozicija: 'MID',
    subPozicija: 'Vezni',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1988-03-10',
    brojDresa: 10,
    visinaCm: 184,
  },
  {
    id: 'mandzukic',
    ime: 'Mario Mandžukić',
    aliasi: ['Mandzukic'],
    klub: 'Juventus (legenda)',
    liga: 'Serie A',
    pozicija: 'FWD',
    subPozicija: 'Napadač',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1986-05-21',
    brojDresa: 17,
    visinaCm: 190,
  },
  {
    id: 'subasic',
    ime: 'Danijel Subašić',
    aliasi: ['Subasic'],
    klub: 'Monaco (legenda)',
    liga: 'Ligue 1',
    pozicija: 'GK',
    subPozicija: 'Vratar',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1984-10-27',
    brojDresa: 23,
    visinaCm: 191,
  },
  {
    id: 'corluka',
    ime: 'Vedran Ćorluka',
    aliasi: ['Corluka'],
    klub: 'Lokomotiv Moskva (legenda)',
    liga: 'Premier Liga RU',
    pozicija: 'DEF',
    subPozicija: 'Stoper',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1986-02-05',
    brojDresa: 4,
    visinaCm: 192,
  },
  {
    id: 'lovren',
    ime: 'Dejan Lovren',
    aliasi: ['Lovren'],
    klub: 'Lyon (legenda)',
    liga: 'Ligue 1',
    pozicija: 'DEF',
    subPozicija: 'Stoper',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1989-07-05',
    brojDresa: 6,
    visinaCm: 188,
  },
  {
    id: 'eduardo',
    ime: 'Eduardo da Silva',
    aliasi: ['Eduardo'],
    klub: 'Arsenal (legenda)',
    liga: 'Premier League',
    pozicija: 'FWD',
    subPozicija: 'Napadač',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1983-02-25',
    brojDresa: 9,
    visinaCm: 178,
  },
  {
    id: 'kovac',
    ime: 'Niko Kovač',
    aliasi: ['Kovac', 'Niko Kovac'],
    klub: 'Bayern (legenda)',
    liga: 'Bundesliga',
    pozicija: 'MID',
    subPozicija: 'Defenzivni vezni',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1971-10-15',
    brojDresa: 6,
    visinaCm: 184,
  },
  {
    id: 'simunic',
    ime: 'Josip Šimunić',
    aliasi: ['Simunic'],
    klub: 'Hertha (legenda)',
    liga: 'Bundesliga',
    pozicija: 'DEF',
    subPozicija: 'Stoper',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1978-02-18',
    brojDresa: 5,
    visinaCm: 195,
  },
  {
    id: 'kranjcar',
    ime: 'Niko Kranjčar',
    aliasi: ['Kranjcar'],
    klub: 'Tottenham (legenda)',
    liga: 'Premier League',
    pozicija: 'MID',
    subPozicija: 'Ofenzivni vezni',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1984-08-13',
    brojDresa: 19,
    visinaCm: 184,
  },
  {
    id: 'vrsaljko',
    ime: 'Šime Vrsaljko',
    aliasi: ['Vrsaljko'],
    klub: 'Olympiakos (legenda)',
    liga: 'Super League GR',
    pozicija: 'DEF',
    subPozicija: 'Desni bek',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1992-01-20',
    brojDresa: 2,
    visinaCm: 180,
  },
  {
    id: 'pletikosa',
    ime: 'Stipe Pletikosa',
    aliasi: ['Pletikosa'],
    klub: 'Rostov (legenda)',
    liga: 'Premier Liga RU',
    pozicija: 'GK',
    subPozicija: 'Vratar',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1979-01-08',
    brojDresa: 1,
    visinaCm: 193,
  },
  {
    id: 'bennacer',
    ime: 'Ismaël Bennacer',
    aliasi: ['Ismael Bennacer', 'Bennacer'],
    klub: 'Dinamo Zagreb',
    liga: 'HNL',
    pozicija: 'MID',
    subPozicija: 'Vezni',
    nacionalnost: 'Alžir',
    kontinent: 'Afrika',
    datumRodjenja: '1997-12-01',
    brojDresa: 4,
    visinaCm: 175,
  },
  {
    id: 'luka-stojkovic',
    ime: 'Luka Stojković',
    aliasi: ['Luka Stojkovic', 'Stojković', 'Stojkovic'],
    klub: 'Dinamo Zagreb',
    liga: 'HNL',
    pozicija: 'MID',
    subPozicija: 'Ofenzivni vezni',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '2003-10-28',
    brojDresa: 7,
    visinaCm: 182,
  },
  {
    id: 'dion-beljo',
    ime: 'Dion Beljo',
    aliasi: ['Beljo'],
    klub: 'Dinamo Zagreb',
    liga: 'HNL',
    pozicija: 'FWD',
    subPozicija: 'Napadač',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '2002-03-01',
    brojDresa: 9,
    visinaCm: 195,
  },
  {
    id: 'gabriel-vidovic',
    ime: 'Gabriel Vidović',
    aliasi: ['Gabriel Vidovic', 'Vidović', 'Vidovic'],
    klub: 'Dinamo Zagreb',
    liga: 'HNL',
    pozicija: 'MID',
    subPozicija: 'Ofenzivni vezni',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '2003-12-01',
    brojDresa: 10,
    visinaCm: 180,
  },
  {
    id: 'edgar-gonzalez',
    ime: 'Edgar González',
    aliasi: ['Edgar Gonzalez', 'Edgar'],
    klub: 'Hajduk Split',
    liga: 'HNL',
    pozicija: 'DEF',
    subPozicija: 'Stoper',
    nacionalnost: 'Španjolska',
    kontinent: 'Europa',
    datumRodjenja: '1997-04-01',
    brojDresa: 3,
    visinaCm: 193,
  },
  {
    id: 'adrion-pajaziti',
    ime: 'Adrion Pajaziti',
    aliasi: ['Pajaziti'],
    klub: 'Hajduk Split',
    liga: 'HNL',
    pozicija: 'MID',
    subPozicija: 'Vezni',
    nacionalnost: 'Albanija',
    kontinent: 'Europa',
    datumRodjenja: '2002-11-16',
    brojDresa: 4,
    visinaCm: 178,
  },
  {
    id: 'ismael-diallo',
    ime: 'Ismaël Diallo',
    aliasi: ['Ismael Diallo', 'Diallo'],
    klub: 'Hajduk Split',
    liga: 'HNL',
    pozicija: 'DEF',
    subPozicija: 'Lijevi bek',
    nacionalnost: 'Obala Bjelokosti',
    kontinent: 'Afrika',
    datumRodjenja: '1997-01-29',
    brojDresa: 5,
    visinaCm: 178,
  },
  {
    id: 'hugo-guillamon',
    ime: 'Hugo Guillamón',
    aliasi: ['Hugo Guillamon', 'Guillamón', 'Guillamon'],
    klub: 'Hajduk Split',
    liga: 'HNL',
    pozicija: 'DEF',
    subPozicija: 'Stoper',
    nacionalnost: 'Španjolska',
    kontinent: 'Europa',
    datumRodjenja: '2000-01-31',
    brojDresa: 6,
    visinaCm: 176,
  },
  {
    id: 'niko-sigur',
    ime: 'Niko Sigur',
    aliasi: ['Sigur'],
    klub: 'Hajduk Split',
    liga: 'HNL',
    pozicija: 'MID',
    subPozicija: 'Defenzivni vezni',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '2003-09-09',
    brojDresa: 8,
    visinaCm: 176,
  },
  {
    id: 'mile-skoric',
    ime: 'Mile Škorić',
    aliasi: ['Mile Skoric', 'Škorić', 'Skoric'],
    klub: 'Rijeka',
    liga: 'HNL',
    pozicija: 'DEF',
    subPozicija: 'Stoper',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1991-06-19',
    brojDresa: 5,
    visinaCm: 189,
  },
  {
    id: 'stjepan-radeljic',
    ime: 'Stjepan Radeljić',
    aliasi: ['Stjepan Radeljic', 'Radeljić', 'Radeljic'],
    klub: 'Rijeka',
    liga: 'HNL',
    pozicija: 'DEF',
    subPozicija: 'Stoper',
    nacionalnost: 'Bosna i Hercegovina',
    kontinent: 'Europa',
    datumRodjenja: '1997-09-05',
    brojDresa: 6,
    visinaCm: 201,
  },
  {
    id: 'duje-cop',
    ime: 'Duje Čop',
    aliasi: ['Duje Cop', 'Čop', 'Cop'],
    klub: 'Rijeka',
    liga: 'HNL',
    pozicija: 'FWD',
    subPozicija: 'Napadač',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1990-02-01',
    brojDresa: 9,
    visinaCm: 182,
  },
  {
    id: 'tiago-dantas',
    ime: 'Tiago Dantas',
    aliasi: ['Dantas'],
    klub: 'Rijeka',
    liga: 'HNL',
    pozicija: 'MID',
    subPozicija: 'Vezni',
    nacionalnost: 'Portugal',
    kontinent: 'Europa',
    datumRodjenja: '2000-12-24',
    brojDresa: 26,
    visinaCm: 170,
  },
  {
    id: 'damir-kreilach',
    ime: 'Damir Kreilach',
    aliasi: ['Kreilach'],
    klub: 'Rijeka',
    liga: 'HNL',
    pozicija: 'MID',
    subPozicija: 'Vezni',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1989-04-16',
    brojDresa: 87,
    visinaCm: 186,
  },
  {
    id: 'jakov-filipovic',
    ime: 'Jakov Filipović',
    aliasi: ['Jakov Filipovic', 'Filipović', 'Filipovic'],
    klub: 'Gorica',
    liga: 'HNL',
    pozicija: 'DEF',
    subPozicija: 'Stoper',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1992-10-17',
    brojDresa: 4,
    visinaCm: 190,
  },
  {
    id: 'mateo-les',
    ime: 'Mateo Leš',
    aliasi: ['Mateo Les', 'Leš', 'Les'],
    klub: 'Gorica',
    liga: 'HNL',
    pozicija: 'DEF',
    subPozicija: 'Stoper',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '2000-03-25',
    brojDresa: 5,
    visinaCm: 186,
  },
  {
    id: 'jurica-prsir',
    ime: 'Jurica Pršir',
    aliasi: ['Jurica Prsir', 'Pršir', 'Prsir'],
    klub: 'Gorica',
    liga: 'HNL',
    pozicija: 'MID',
    subPozicija: 'Vezni',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '2000-05-29',
    brojDresa: 10,
    visinaCm: 181,
  },
  {
    id: 'ivan-fiolic',
    ime: 'Ivan Fiolić',
    aliasi: ['Ivan Fiolic', 'Fiolić', 'Fiolic'],
    klub: 'Gorica',
    liga: 'HNL',
    pozicija: 'MID',
    subPozicija: 'Ofenzivni vezni',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1996-04-29',
    brojDresa: 18,
    visinaCm: 176,
  },
  {
    id: 'domagoj-pavicic',
    ime: 'Domagoj Pavičić',
    aliasi: ['Domagoj Pavicic', 'Pavičić', 'Pavicic'],
    klub: 'Gorica',
    liga: 'HNL',
    pozicija: 'MID',
    subPozicija: 'Vezni',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1994-03-09',
    brojDresa: 24,
    visinaCm: 179,
  },
  {
    id: 'franko-kolic',
    ime: 'Franko Kolić',
    aliasi: ['Franko Kolic', 'Kolić', 'Kolic'],
    klub: 'Istra 1961',
    liga: 'HNL',
    pozicija: 'GK',
    subPozicija: 'Vratar',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '2003-02-07',
    brojDresa: 1,
    visinaCm: 190,
  },
  {
    id: 'dario-maresic',
    ime: 'Dario Maresić',
    aliasi: ['Dario Maresic', 'Maresić', 'Maresic'],
    klub: 'Istra 1961',
    liga: 'HNL',
    pozicija: 'DEF',
    subPozicija: 'Stoper',
    nacionalnost: 'Austrija',
    kontinent: 'Europa',
    datumRodjenja: '1999-09-29',
    brojDresa: 4,
    visinaCm: 183,
  },
  {
    id: 'josip-radosevic',
    ime: 'Josip Radošević',
    aliasi: ['Josip Radosevic', 'Radošević', 'Radosevic'],
    klub: 'Istra 1961',
    liga: 'HNL',
    pozicija: 'MID',
    subPozicija: 'Defenzivni vezni',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1994-04-03',
    brojDresa: 5,
    visinaCm: 180,
  },
  {
    id: 'smail-prevljak',
    ime: 'Smail Prevljak',
    aliasi: ['Prevljak'],
    klub: 'Istra 1961',
    liga: 'HNL',
    pozicija: 'FWD',
    subPozicija: 'Napadač',
    nacionalnost: 'Bosna i Hercegovina',
    kontinent: 'Europa',
    datumRodjenja: '1995-05-10',
    brojDresa: 9,
    visinaCm: 187,
  },
  {
    id: 'stjepan-loncar',
    ime: 'Stjepan Lončar',
    aliasi: ['Stjepan Loncar', 'Lončar', 'Loncar'],
    klub: 'Istra 1961',
    liga: 'HNL',
    pozicija: 'MID',
    subPozicija: 'Vezni',
    nacionalnost: 'Bosna i Hercegovina',
    kontinent: 'Europa',
    datumRodjenja: '1996-11-10',
    brojDresa: 10,
    visinaCm: 187,
  },
  {
    id: 'krunoslav-hendija',
    ime: 'Krunoslav Hendija',
    aliasi: ['Hendija'],
    klub: 'Lokomotiva Zagreb',
    liga: 'HNL',
    pozicija: 'GK',
    subPozicija: 'Vratar',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1989-03-19',
    brojDresa: 1,
    visinaCm: 194,
  },
  {
    id: 'leonardo-sigali',
    ime: 'Leonardo Sigali',
    aliasi: ['Sigali'],
    klub: 'Lokomotiva Zagreb',
    liga: 'HNL',
    pozicija: 'DEF',
    subPozicija: 'Stoper',
    nacionalnost: 'Argentina',
    kontinent: 'Južna Amerika',
    datumRodjenja: '1987-05-29',
    brojDresa: 4,
    visinaCm: 184,
  },
  {
    id: 'domagoj-antolic',
    ime: 'Domagoj Antolić',
    aliasi: ['Domagoj Antolic', 'Antolić', 'Antolic'],
    klub: 'Lokomotiva Zagreb',
    liga: 'HNL',
    pozicija: 'MID',
    subPozicija: 'Vezni',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1990-06-30',
    brojDresa: 8,
    visinaCm: 180,
  },
  {
    id: 'hubert-sobol',
    ime: 'Hubert Sobol',
    aliasi: ['Sobol'],
    klub: 'Lokomotiva Zagreb',
    liga: 'HNL',
    pozicija: 'FWD',
    subPozicija: 'Napadač',
    nacionalnost: 'Poljska',
    kontinent: 'Europa',
    datumRodjenja: '2000-06-25',
    brojDresa: 9,
    visinaCm: 183,
  },
  {
    id: 'matija-jesenovic',
    ime: 'Matija Jesenović',
    aliasi: ['Matija Jesenovic', 'Jesenović', 'Jesenovic'],
    klub: 'Slaven Belupo',
    liga: 'HNL',
    pozicija: 'GK',
    subPozicija: 'Vratar',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1997-12-19',
    brojDresa: 1,
    visinaCm: 193,
  },
  {
    id: 'dominik-kovacic',
    ime: 'Dominik Kovačić',
    aliasi: ['Dominik Kovacic', 'Kovačić', 'Kovacic'],
    klub: 'Slaven Belupo',
    liga: 'HNL',
    pozicija: 'DEF',
    subPozicija: 'Stoper',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1994-01-05',
    brojDresa: 4,
    visinaCm: 192,
  },
  {
    id: 'andrija-filipovic',
    ime: 'Andrija Filipović',
    aliasi: ['Andrija Filipovic', 'Filipović', 'Filipovic'],
    klub: 'Slaven Belupo',
    liga: 'HNL',
    pozicija: 'FWD',
    subPozicija: 'Napadač',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1997-04-18',
    brojDresa: 7,
    visinaCm: 181,
  },
  {
    id: 'adriano-jagusic',
    ime: 'Adriano Jagušić',
    aliasi: ['Adriano Jagusic', 'Jagušić', 'Jagusic'],
    klub: 'Slaven Belupo',
    liga: 'HNL',
    pozicija: 'MID',
    subPozicija: 'Vezni',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '2005-09-06',
    brojDresa: 8,
    visinaCm: 174,
  },
  {
    id: 'oliver-zelenika',
    ime: 'Oliver Zelenika',
    aliasi: ['Zelenika'],
    klub: 'Varaždin',
    liga: 'HNL',
    pozicija: 'GK',
    subPozicija: 'Vratar',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1993-05-14',
    brojDresa: 1,
    visinaCm: 191,
  },
  {
    id: 'david-puclin',
    ime: 'David Puclin',
    aliasi: ['Puclin'],
    klub: 'Varaždin',
    liga: 'HNL',
    pozicija: 'MID',
    subPozicija: 'Vezni',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1992-06-17',
    brojDresa: 6,
    visinaCm: 177,
  },
  {
    id: 'marko-dabro',
    ime: 'Marko Dabro',
    aliasi: ['Dabro'],
    klub: 'Varaždin',
    liga: 'HNL',
    pozicija: 'FWD',
    subPozicija: 'Napadač',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1997-03-28',
    brojDresa: 9,
    visinaCm: 178,
  },
  {
    id: 'leon-belcar',
    ime: 'Leon Belcar',
    aliasi: ['Belcar'],
    klub: 'Varaždin',
    liga: 'HNL',
    pozicija: 'MID',
    subPozicija: 'Vezni',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '2002-01-04',
    brojDresa: 10,
    visinaCm: 186,
  },
  {
    id: 'mate-antunovic',
    ime: 'Mate Antunović',
    aliasi: ['Mate Antunovic', 'Antunović', 'Antunovic'],
    klub: 'Varaždin',
    liga: 'HNL',
    pozicija: 'FWD',
    subPozicija: 'Napadač',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '2004-03-03',
    brojDresa: 11,
    visinaCm: 180,
  },
  {
    id: 'marino-bulat',
    ime: 'Marino Bulat',
    aliasi: ['Bulat'],
    klub: 'Vukovar 1991',
    liga: 'HNL',
    pozicija: 'GK',
    subPozicija: 'Vratar',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1999-06-26',
    brojDresa: 1,
    visinaCm: 194,
  },
  {
    id: 'dominik-mulac',
    ime: 'Dominik Mulac',
    aliasi: ['Mulac'],
    klub: 'Vukovar 1991',
    liga: 'HNL',
    pozicija: 'DEF',
    subPozicija: 'Stoper',
    nacionalnost: 'Hrvatska',
    kontinent: 'Europa',
    datumRodjenja: '1999-02-03',
    brojDresa: 4,
    visinaCm: 185,
  },
  {
    id: 'lun-boncina',
    ime: 'Lun Bončina',
    aliasi: ['Lun Boncina', 'Bončina', 'Boncina'],
    klub: 'Vukovar 1991',
    liga: 'HNL',
    pozicija: 'FWD',
    subPozicija: 'Napadač',
    nacionalnost: 'Slovenija',
    kontinent: 'Europa',
    datumRodjenja: '2002-12-02',
    brojDresa: 9,
    visinaCm: 182,
  },
  {
    id: 'keyendrah-simmonds',
    ime: 'Keyendrah Simmonds',
    aliasi: ['Simmonds'],
    klub: 'Vukovar 1991',
    liga: 'HNL',
    pozicija: 'FWD',
    subPozicija: 'Napadač',
    nacionalnost: 'Engleska',
    kontinent: 'Europa',
    datumRodjenja: '2001-05-31',
    brojDresa: 11,
    visinaCm: 180,
  },
];

// Pomoćne funkcije

const POSITION_GROUP = ['GK', 'DEF', 'MID', 'FWD'];

export function calcAge(datumRodjenja, today = new Date()) {
  const dob = new Date(datumRodjenja);
  let age = today.getFullYear() - dob.getFullYear();
  const m = today.getMonth() - dob.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) age--;
  return age;
}

export function pickDailyPlayer(date = new Date(), pool = PLAYERS) {
  // Deterministički indeks iz lokalnog datuma - puzzle se mijenja u lokalnu ponoć
  const y = date.getFullYear();
  const m = date.getMonth() + 1;
  const d = date.getDate();
  const dayNum = y * 10000 + m * 100 + d;
  // Jednostavan stabilan hash
  let h = 2166136261;
  const s = String(dayNum);
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = (h * 16777619) >>> 0;
  }
  const idx = h % pool.length;
  return pool[idx];
}

export function puzzleNumber(date = new Date(), epoch = new Date(2026, 3, 25)) {
  // Broj puzzleja od epoch dana
  const ms = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime()
    - new Date(epoch.getFullYear(), epoch.getMonth(), epoch.getDate()).getTime();
  return Math.floor(ms / 86400000) + 1;
}

// Poredak pozicija - susjedne se broje kao "blizu" (žuto)
export function comparePosition(guess, target) {
  if (guess === target) return 'eq';
  const a = POSITION_GROUP.indexOf(guess);
  const b = POSITION_GROUP.indexOf(target);
  if (a >= 0 && b >= 0 && Math.abs(a - b) === 1) return 'near';
  return 'no';
}

export function compareScalar(guess, target, tolerance) {
  if (guess === target) return { match: 'eq', dir: null };
  const diff = Math.abs(guess - target);
  const dir = guess < target ? 'up' : 'down';
  if (diff <= tolerance) return { match: 'near', dir };
  return { match: 'no', dir };
}

export function compareCategorical(guess, target, opts = {}) {
  if (guess === target) return 'eq';
  if (opts.nearKey && opts.guessNear && opts.targetNear) {
    if (opts.guessNear === opts.targetNear) return 'near';
  }
  return 'no';
}

export function buildComparison(guess, target, today = new Date()) {
  const guessAge = calcAge(guess.datumRodjenja, today);
  const targetAge = calcAge(target.datumRodjenja, today);

  return {
    klub: { value: guess.klub, match: guess.klub === target.klub ? 'eq' : 'no' },
    liga: { value: guess.liga, match: guess.liga === target.liga ? 'eq' : 'no' },
    pozicija: {
      value: guess.subPozicija,
      match: comparePosition(guess.pozicija, target.pozicija),
    },
    nacionalnost: {
      value: guess.nacionalnost,
      match: compareCategorical(guess.nacionalnost, target.nacionalnost, {
        guessNear: guess.kontinent,
        targetNear: target.kontinent,
      }),
    },
    dob: (() => {
      const c = compareScalar(guessAge, targetAge, 2);
      return { value: guessAge, ...c };
    })(),
    brojDresa: (() => {
      const c = compareScalar(guess.brojDresa, target.brojDresa, 3);
      return { value: guess.brojDresa, ...c };
    })(),
    visinaCm: (() => {
      const c = compareScalar(guess.visinaCm, target.visinaCm, 3);
      return { value: `${guess.visinaCm} cm`, ...c };
    })(),
  };
}

export function isWinningGuess(guess, target) {
  return guess.id === target.id;
}

// Lookup po imenu / aliasu (case-insensitive, ignorira dijakritike)
function normalize(s) {
  return (s || '')
    .toString()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9 ]/g, '')
    .trim();
}

export function searchPlayers(query, limit = 8, pool = PLAYERS) {
  const q = normalize(query);
  if (q.length < 1) return [];
  const results = [];
  for (const p of pool) {
    const candidates = [p.ime, ...(p.aliasi || [])].map(normalize);
    let score = 0;
    for (const c of candidates) {
      if (c === q) { score = Math.max(score, 100); break; }
      if (c.startsWith(q)) score = Math.max(score, 80);
      else if (c.includes(' ' + q)) score = Math.max(score, 60);
      else if (c.includes(q)) score = Math.max(score, 40);
    }
    if (score > 0) results.push({ player: p, score });
  }
  results.sort((a, b) => b.score - a.score || a.player.ime.localeCompare(b.player.ime));
  return results.slice(0, limit).map((r) => r.player);
}

export function findPlayerByName(name, pool = PLAYERS) {
  const q = normalize(name);
  for (const p of pool) {
    const candidates = [p.ime, ...(p.aliasi || [])].map(normalize);
    if (candidates.includes(q)) return p;
  }
  return null;
}
